import { atom } from 'recoil';

export { studentsAtom };

const studentsAtom = atom({
    key: {
        name: 'students'
    },
    default: []
});

   